import type { IconData } from '@stacksjs/iconify-core'

export const subject: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 8H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m-8 10H3a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2m8-5H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default subject
